import { render, staticRenderFns } from "./BetonObjekatCRUD.vue?vue&type=template&id=7f72cc04&"
import script from "./BetonObjekatCRUD.vue?vue&type=script&lang=js&"
export * from "./BetonObjekatCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports